module.exports = __webpack_public_path__ + "img/service-software-3.287c5828.jpg";